import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import config from "../../lib/config"
import moment from 'moment';
import Exportexcel from "../pdf/Excelexport"
import Exportpdf from "../pdf/Exportpdf"
import Exportcsv from "../pdf/Exportcsv"
import { useParams, useNavigate } from 'react-router-dom';
import { HideSTB, SBTMaySent, SoulGet, updateSBTStatus } from '../../actions/users';

const ViewCollection = () => {

  const navigate = useNavigate()
  const [userdet, setUser] = useState();
  const [responsive, setresponsive] = useState(true);
  const [allcheck, setAllcheck] = useState(false);
  const [exportdata, setExportdata] = useState([]); 
  const { Owner, Id } = useParams();

  useEffect(() => {
    getTokenData();
  }, []);
  const getTokenData = async () => {
    var reqdata = {
      CollectionName: Id,
      Address: Owner,
    };
    var test = await SoulGet(reqdata);
    if (test.userValue.Message == "success") {
      setUser(test.userValue.ListingCollection);
      var ddd = test.userValue.ListingCollection.map(({ _id, tokenOwnerDb, ...rest }) => {

        return rest
      })
      setExportdata(ddd)
    }
    else {

    }
  };

  const Enlarge = (e) => {
    if (Number(e.target.naturalWidth) > 700 || Number(e.target.naturalHeight) > 700) {
      e.target.width = String(Number(e.target.naturalWidth) / 4)
      e.target.height = String(Number(e.target.naturalHeight) / 4)
    }
    else {
      e.target.width = String(Number(e.target.naturalWidth) / 2)
      e.target.height = String(Number(e.target.naturalHeight) / 2)
    }
  }
  const VEnlarge = (e) => {
    if (Number(e.target.videoWidth) > 700 || Number(e.target.videoHeight) > 700) {
      e.target.width = String(Number(e.target.videoWidth) / 4)
      e.target.height = String(Number(e.target.videoHeight) / 4)
    }
    else {
      e.target.width = String(Number(e.target.videoWidth) / 2)
      e.target.height = String(Number(e.target.videoHeight) / 2)
    }
  }
  const Reset = (e) => {
    e.target.width = "25"
    e.target.height = "25"
  }
  const back = async () => {
    window.location.href = "/SupportTicket";
  };
  const handleChangemaysent = async (event) => {
    let { id, checked } = event.target;
    let handlemaychange = await updateSBTStatus({ email: id, maySentChecked: checked });
    if (handlemaychange.Success) {
      toastAlert("success", 'Selected');

      getTokenData()

    }
    else {
      toastAlert("error", 'Error on Server');
    }
  }

  const setMaySent = async (data) => {
    if (data?.target) {
      if (userdet.length > 0) {

        var resp = await SBTMaySent({ all: data.target.checked });
        if (resp?.Success) {
          setAllcheck(!allcheck)
          toastAlert("success", 'Success...Please wait for data refresh');
          getTokenData()
        }
        else
          toastAlert("error", resp.Message)
      } else {
        toastAlert("error", "Subscribers are not yet")
      }
    } else {
      var payload = {
        email: data.email,
        maySent: !data.maySent
      }

      var resp = await SBTMaySent(payload);
      if (resp?.Success) {
        toastAlert("success", 'Success...Please wait for data refresh');
        getTokenData()
      }
      else
        toastAlert("error", resp.msg)
    }

  }
  const deleteUser = async () => {
    var send = {
      Show: "Hide"
    }
    let handlemaychange = await HideSTB(send);
    if (handlemaychange.Success) {
      toastAlert("success", 'Collection Hide Succesfully');
      getTokenData()
    }
    else {
      toastAlert("error", 'Error on Server');
    }
  }

  const Show = async () => {
    var send = {
      Show: "Show"
    }
    let handlemaychange = await HideSTB(send);
    if (handlemaychange.Success) {
      toastAlert("success", 'Collection is Visible Now');
      getTokenData()
    }
    else {
      toastAlert("error", 'Error on Server');
    }
  }

  const configdata = {
    page_size: 10,
    length_menu: [10, 20, 50],
    filename: "Users",
    no_data_text: 'No user found!',

    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: <>Previous</>,
        next: <>Next</>,
        last: "Last",
      }
    },
    show_length_menu: true,
    show_filter: true,
    show_pagination: true,
    show_info: true,
    defaultSortAsc: true,
  };

  const columns = [
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: record => {
        return (
          <div className="exchange_table_values text-center">
            {record && <input type="checkbox" name={record.tokenID} id={record.tokenID} checked={record.MayChecked == "true" || record.MayChecked == true ? true : false} onChange={(event) => { handleChangemaysent(event) }} />}
          </div>
        );
      }
    },
    {
      key: "ind",
      text: "SNO",
      className: "name",
      align: "left",
      sortable: true,
      cell: (row, index, column, id) =>
        <p className="exchange_table_values text-center">{index + 1}</p>
    },
    {

      key: "tokenID",
      text: "Token Count",
      className: "tokenId",
      align: "left",
      sortable: false,
      cell: (val) =>
        <p className="exchange_table_values text-center">{val.tokenID}</p>
    },
    {
      key: "additionalImage",
      text: "NFT Token Preview",
      className: "tokenOwner",
      align: "left",
      sortable: false,
      cell: record =>
        <div className="exchange_table_values text-center">
          {record.CoverImg &&
            (record.CoverImg.split(".").pop() !== "mp4") ? (
            <img
              onMouseOver={(e) => Enlarge(e)}
              onMouseLeave={(e) => Reset(e)}
              width="25"
              height="25"
              src={`${config.Back_Url}/${record.FinalOutBulkPath}`}
            />
          )
            :
            (
              <video
                onMouseOver={(e) => VEnlarge(e)}
                onMouseLeave={(e) => Reset(e)}
                width="25"
                height="25"
                autoPlay
                muted
                loop
                type="video/mp4"
                src={`${config.Back_Url}/${record.FinalOutBulkPath}`}
              />
            )}
        </div>
    },
    {
      key: "NFTImageName",
      text: "Token Name",
      className: "NFTImageName",
      align: "left",
      sortable: false,
      cell: (val) =>
        <p className="exchange_table_values text-center">{val.NFTImageName}</p>
    },
    {

      key: "tokenCreator",
      text: "Token Creator",
      className: "tokenCreator",
      align: "left",
      sortable: false,
      cell: (val) =>
        <p className="exchange_table_values text-center">{val.tokenCreator}</p>
    }, {

      key: "tokenOwner",
      text: "Token Owner",
      className: "tokenOwner",
      align: "left",
      sortable: false,
      cell: val =>
        <div className="exchange_table_values text-center">{String(val.tokenOwner)}</div>
    },

    {

      key: "status",
      text: "Token Status",
      className: "status",
      align: "left",
      sortable: false,
      cell: val =>
        <div className="exchange_table_values text-center">{val.status}</div>
    },
    {

      key: "ipfsimage",
      text: "Image Hash Value",
      className: "image",
      align: "left",
      sortable: false,
      cell: record =>
        <div className="exchange_table_values text-center"><p>{(record.ipfsimage)}</p></div>


    },
    {
      key: "timestamp",
      text: "Created At",
      className: "Date",
      align: "left",
      sortable: false,
      cell: record =>
        <div className="exchange_table_values text-center"><p>{moment(record.timestamp).format('MMMM,Do YYYY, hh:mm A')}</p></div>
    },
    {
      key: "deleted",
      text: "Hide/Show",
      className: "Date",
      align: "left",
      sortable: false,
      cell: record =>
        <div className="exchange_table_values text-center"><p>{(record.deleted == "true") ? "Visible" : "Hidden"}</p></div>
    },
  ];

  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={'SBT List'} />

            <div className="common_page_scroller mt-5 pe-2">
            <div>
                              <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>
                            </div>
              <div className="page_header">
                <h2>SBT List</h2>
                <div>
                  <div className="selection_sec">
                    <div className="checkbox_sec_user">
                      <span>SELECT ALL</span>
                      <input type="checkbox" className='selectall ms-2' checked={allcheck} onChange={(e) => setMaySent(e)} />
                    </div>

                    <div>
                      <button className="ms-3" variant="contained" onClick={() => deleteUser()} color="primary">Hide NFTS</button>
                    </div>
                    <div>
                      <button className="ms-3" variant="contained" onClick={() => Show()} color="primary">Show NFTS</button>
                    </div>
                  </div>

                </div>
              </div>
              <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                <ReactDatatable
                  className="table table-striped table-bordered table-responsive"
                  responsive={responsive}
                  config={configdata}
                  records={userdet}
                  columns={columns}
                />
              </div>
            </div>
            <div className='bottom_btn_comp'>
              <Exportexcel excelData={exportdata} fileName={'Token List'} />
              <Exportpdf pdfData={exportdata} fileName={'Token List'} />
              <Exportcsv csvData={exportdata} fileName={'Token List'} />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default ViewCollection